export const API_GET_ALL_NURSE = "API_GET_ALL_NURSE";
export const API_GET_ALL_NURSE_SUCCESS = "API_GET_ALL_NURSE_SUCCESS";
export const API_GET_ALL_NURSE_FAIL = "API_GET_ALL_NURSE_FAIL";

export const API_GET_ALL_NETWORKS = "API_GET_ALL_NETWORKS";
export const API_GET_ALL_NETWORKS_SUCCESS = "API_GET_ALL_NETWORKS_SUCCESS";
export const API_GET_ALL_NETWORKS_FAIL = "API_GET_ALL_NETWORKS_FAIL";
